import api from 'Application/api/api';

const getPublicTemplateQuestionFilesDownloadRequest = (
    templateId,
    questionId,
    isCustomQuestion,
    downloadRequestId,
    checksum,
    load,
    cancelToken = null,
) =>
    api.get(
        `public/project-manager/templates/${templateId}/questionnaire/questions/${questionId}/${
            isCustomQuestion ? 1 : 0
        }/files/download-requests/${downloadRequestId}`,
        {
            params: {
                load,
                checksum,
            },
            cancelToken,
        },
    );

export default getPublicTemplateQuestionFilesDownloadRequest;
